let timer;

export default {
    async createAccount(context, body) {
        let url = process.env.VUE_APP_BACKEND_BASE_URL+"/api/bridge";
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(body)
        });

        let _response = await response.json();
        console.log("_response",_response);
        
        if(_response.response.error){
            return _response.response
        }

        const actionPayload = {
            email: body.email,
            password: body.password,
        };
        await context.dispatch('auth', actionPayload);
        window.location.reload();
    },

    async sendMail(context,body){
        return await this.$api.info.allApi(body)
        .then( data => {
            return data
        })
    },

    async login(context, payload) {
        return context.dispatch('auth', payload);
    },
    async auth(context, payload) {

        let url = process.env.VUE_APP_BACKEND_BASE_URL+"/api/bridge";
        let body = {
            type: "login",
            email:payload.email,
            password: payload.password
        }
        const response = await fetch(url, {
          method: 'POST',
          body: JSON.stringify(body)
        });

        const responseData = await response.json();
         
        // if( !responseData.token ){
        if( !responseData.response.jwt ){
            const error = new Error(
                responseData.message || 'Failed to authenticate. Check your login data.'
            );
            throw error;
        } 

        // const expiresIn = 5000;
        const expiresIn = ( 60*60*24*5 )*1000;
        // token dura 5gg
        const expirationDate = new Date().getTime() + expiresIn;

        // localStorage.setItem('token', responseData.token);
        localStorage.setItem('profile', JSON.stringify(responseData));
        localStorage.setItem('tokenExpiration', expirationDate);

        timer = setTimeout(function () {
            context.dispatch('autoLogout');
        }, expiresIn);

        responseData.token = responseData.response.jwt

        context.commit('setAuthprofile', responseData );

        return true
        
        
    },
    async tryLogin(context) {
        const profile = await JSON.parse(localStorage.getItem('profile'));
        let token = null
        if(profile && profile.response && profile.response.jwt){
            token = profile.response.jwt
        } else {
            localStorage.removeItem('profile');
        }
        const tokenExpiration = await localStorage.getItem('tokenExpiration');

        const expiresIn = +tokenExpiration - new Date().getTime();

        if (expiresIn < 0) {
            return { message: 'expired token' };
        }
        
        timer = setTimeout(function () {
            context.dispatch('autoLogout');
        }, expiresIn);
        
        
        if (token && profile) {
            profile.token = token
            console.log('auto logging in the profile');
            context.commit('setAuthprofile', profile );
            console.log("5");
            return profile
        } else {
            return { message: 'invalid token' };
        }
    },
    
    logout(context) {

        localStorage.removeItem('profile');
        localStorage.removeItem('tokenExpiration');

        clearTimeout(timer);

        context.commit('setAuthprofile', null );
    },
    autoLogout(context) {
        context.dispatch('logout');
        context.commit('setAutoLogout');
    },

    async resetPass(context, email) {

        let body = {
            "type": "forgot_password",
            "email": email
        }

        let url = process.env.VUE_APP_BACKEND_BASE_URL + "/api/bridge";
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(body)
        });

        let _response = await response.json();
        console.log("_responseresetPass",_response);
        
        // controllare se _response.response è un oggetto e se ha la proprietà error
        if(typeof _response.response === 'object' && _response.response.error){
            return _response.response
        }

        return _response
    },
    async changePass(context, body) {

        body.type = "save_password"

        let url = process.env.VUE_APP_BACKEND_BASE_URL + "/api/bridge";
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(body)
        }).catch(err => {
            console.log("err",err);
        });

        let _response = await response.json();
        console.log("changePass",_response);
        
        if(_response.response && _response.response.error){
            return _response.response
        }

        return _response
    },
    async confirmUser(context, body) {

        console.log("CONFIRM USER",body);

        let url = process.env.VUE_APP_BACKEND_BASE_URL+"/api/bridge";

        console.log("url",url);

        const response = await fetch(url, {
          method: 'POST',
          body: JSON.stringify(body)
        });

        console.log("response",response);
        
        const responseData = await response.json();
        console.log("responseData",responseData);

        if(responseData.response && responseData.response.error){
            return responseData.response
        }

        return responseData

        // return await this.$api.info.allApi(body)
        // .then( response => {
        
        //     if(response.response && response.response.error){
        //         return response.response
        //     }

        //     return response
        // })

        // console.log("CONFIRM USER",body);

        // let url = process.env.VUE_APP_BACKEND_HOSTNAME + "/casting/confirmed_email";
        // const response = await fetch(url, {
        //     method: 'POST',
        //     body: JSON.stringify(body)
        // }).catch(err => {
        //     console.log("err",err);
        // });

        // let _response = await response.json();
        
        // if(_response.response && _response.response.error){
        //     return _response.response
        // }

        // return _response
    },

    // async resetPass(context, email){
        
    //     return await this.$api.info.resetPass(body)
    //     .then( (response) => {

    //         console.log("respone",response);
    //         return true
    //     })
    // },

    /* Loading */
    setLoadingData(context, new_value){
        context.state.loading_data = new_value
    },

    cantAction(context, user){
        if(user.bloccato){
            context.state.cant_action = 'bloccato'
            return
        } 
        if(user.sospeso){
            context.state.cant_action = 'sospeso'
            return
        } 
        if(!user.profiloPromosso){
            context.state.cant_action = 'non_promosso'
            return
        } 
        

        context.state.cant_action = null
    }


};
